<template>
    <div class="row g-3 mb-4">
        <!-- NAGŁÓWEK W SPÓJNYM STYLU -->
        <div ref="headerRef" class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer" @click="toggleSection">
            <h6 class="fw-bold mb-0">3. Lista towarów / usług</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>

        <!-- TREŚĆ SEKCJI - TABELA -->
        <div class="col-12" v-show="sectionCollapse">
            <div class="table-responsive border rounded mb-2">
                <table class="table table-bordered mb-0 align-middle">
                    <thead class="table-light small">
                        <tr>
                            <th style="width: 40px" class="text-center">Lp</th>
                            <th>Nazwa towaru/usługi</th>
                            <th style="width: 80px">J.m.</th>
                            <th style="width: 110px">GTU</th>
                            <th style="width: 90px">Ilość</th>
                            <th style="width: 130px">Cena netto</th>
                            <th style="width: 110px">VAT %</th>
                            <th style="width: 130px">Cena brutto</th>
                            <th style="width: 40px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in items" :key="idx">
                            <td class="text-center fw-bold small">{{ idx + 1 }}</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" v-model="item.name" required />
                            </td>
                            <td>
                                <input type="text" class="form-control form-control-sm" v-model="item.unit" />
                            </td>
                            <td>
                                <select class="form-select form-select-sm" v-model="item.gtu">
                                    <option value="">Brak</option>
                                    <option v-for="g in 13" :key="g" :value="`GTU_${g < 10 ? '0' + g : g}`">
                                        GTU_{{ g < 10 ? '0' + g : g }}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <input type="number" step="0.01" class="form-control form-control-sm" v-model.number="item.quantity" @input="recalculate(item, 'net')" />
                            </td>
                            <td>
                                <input type="number" step="0.01" class="form-control form-control-sm" v-model.number="item.priceNet" @input="recalculate(item, 'net')" />
                            </td>
                            <td>
                                <select class="form-select form-select-sm" v-model.number="item.vatRate" @change="recalculate(item, 'net')">
                                    <option v-for="v in dicts?.vatRates" :key="v.value" :value="v.value">
                                        {{ v.label }}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <input type="number" step="0.01" class="form-control form-control-sm" v-model.number="item.priceGross" @input="recalculate(item, 'gross')" />
                            </td>
                            <td class="text-center">
                                <button type="button" class="btn btn-sm btn-link text-danger p-0" @click="$emit('removeItem', idx)" v-if="items.length > 1">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- PRZYCISK DODAWANIA POZYCJI POD TABELĄ PO PRAWEJ STRONIE -->
            <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-sm btn-success d-flex align-items-center gap-1" @click="$emit('addItem')">
                    <i class="bi bi-plus-lg"></i>
                    <span>Dodaj pozycję</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue'

const props = defineProps({
    modelValue: {
        type: Array,
        required: true
    },
    dicts: {
        type: Object,
        default: () => ({ vatRates: [] })
    }
})
const headerRef = ref(null)

const emit = defineEmits(['update:modelValue', 'addItem', 'removeItem'])

// Reaktywne wiązanie tablicy pozycji items
const items = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

// Przeliczanie Netto / Brutto na poziomie pozycji
const recalculate = (item, source) => {
    const vat = item.vatRate || 0

    if (source === 'net') {
        item.priceGross = Number((item.priceNet * (1 + vat / 100)).toFixed(2))
    } else if (source === 'gross') {
        item.priceNet = Number((item.priceGross / (1 + vat / 100)).toFixed(2))
    }
}

const sectionCollapse = ref(false)
const toggleSection = async () => {
    sectionCollapse.value = !sectionCollapse.value
    if (sectionCollapse.value) {
        await nextTick()
        headerRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
    user-select: none;
}
</style>